<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateCrop"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.variety')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <info-table
                  :infoColumns="getColumns"
                  :infoData="getInfoData"
                  :showBusinesses="true"
                  :isCard="false"
                >
                  <template slot="addColumn">
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.variety') }}:</strong>
                        </h6>
                        <span
                          v-for="(_, index) in cropForm.varieties_number"
                          :key="index"
                        >
                          <el-tag type="info"
                            >{{ cropForm.variety_names[index] }}
                          </el-tag>
                        </span>
                      </td>
                    </tr>
                  </template>
                </info-table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('vie.Pag.Das.Cro.CropCreateEdit.text1') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import configTable from './crop-table';
import FirstStep from './steps/FirstStep.vue';
import InfoTable from 'src/components/Tables/InfoTable.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
    [InfoTable.name]: InfoTable,
  },
  data() {
    return {
      title: '',
      cropForm: {},
      wizardModel: {},
      map: null,
      renderComponent: true,
    };
  },
  computed: {
    getColumns() {
      return [...configTable().tableColumns];
    },
    getInfoData() {
      return {
        ...{
          ...this.cropForm,
          businesses: this.getBusinessSelected,
        },
      };
    },
    getBusinessSelected() {
      try {
        return this.cropForm.businesses_names.map((element) => {
          return { name: element };
        });
      } catch (error) {
        return [];
      }
    },
  },
  mixins: [MixinPermissions, MixinLoading, MixinMenu, MixinAlert],
  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...this.$refs.firstStep.initialModel,
        businesses_id: [],
        businesses_names: [],
      };
      this.$refs.secondStep.model = {
        varieties_id: [],
        varieties_number: 1,
        variety_names: [],
      };
      this.cropForm = {};
      this.$refs.firstStep.$refs['select-businesses'].model = {
        associations_ids: [],
        businesses_ids: [],
        names: [],
      };
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(model) {
      this.cropForm = { ...this.cropForm, ...model };
    },
    storeUpdateCrop() {
      this.showHideLoading(true);
      this.cropForm.route = 'farms/crops';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.cropForm.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.cropForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/farms/crops',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.cropForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/farms/crops',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },
  mounted() {
    this.selectedItemOnMenu('farms/crops');
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
    this.deselectedItemOnMenu('farms/crops');
  },
};
</script>
